// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2257":"3edadeb5","3667":"c0f73fab"}[chunkId] + ".chunk.css";
};